export default __webpack_public_path__ + "static/media/03_Kom_LoLa.038933cf.jpg";